export const businessTypes = [
  { label: 'Registered', value: 'registered' },
  { label: 'Unregistered', value: 'unregistered' },
];

export const businessIndustries = [
  { label: 'Fashion', value: 'fashion' },
  { label: 'Beauty & Personal Care', value: 'beauty_personal_care' },
  { label: 'Electronics & Gadgets', value: 'electronics_gadgets' },
  { label: 'Home & Furniture', value: 'home_furniture' },
  { label: 'Health & Wellness', value: 'health_wellness' },
  { label: 'Baby, Kids & Toys', value: 'baby_kids_toys' },
  { label: 'Groceries', value: 'groceries' },
  { label: 'Household Essentials', value: 'household_essentials' },
  { label: 'Jewelry Items', value: 'jewelry_items' },
  { label: 'Sports & Outdoor', value: 'sports_outdoor' },
  { label: 'Automotive & Tools', value: 'automotive_tools' },
  { label: 'Books & Stationery', value: 'books_stationery' },
  { label: 'Media Items', value: 'media_items' },
  { label: 'Digital Products', value: 'digital_products' },
  { label: 'Agriculture', value: 'agriculture' },
  { label: 'Construction', value: 'construction' },
  { label: 'Education', value: 'education' },
  { label: 'Finance & Banking', value: 'finance' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Hospitality & Tourism', value: 'hospitality' },
  { label: 'Information Technology', value: 'it' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Real Estate', value: 'real_estate' },
  { label: 'Retail', value: 'retail' },
  { label: 'Technology', value: 'technology' },
  { label: 'Telecommunications', value: 'telecommunications' },
  { label: 'Transportation & Logistics', value: 'transportation' },
  { label: 'Others', value: 'others' },
];

export const validIDTypes = [
  { label: 'Passport', value: 'passport' },
  { label: 'National ID Card', value: 'national_id' },
  { label: "Driver's License", value: 'drivers_license' },
  { label: "Voter's Card", value: 'voters_card' },
];

export const countries = [
  { label: 'Nigeria', value: 'nigeria' },
  { label: 'Ghana', value: 'ghana' },
  { label: 'Kenya', value: 'kenya' },
  { label: 'South Africa', value: 'south_africa' },
  { label: 'United States', value: 'united_states' },
  { label: 'United Kingdom', value: 'united_kingdom' },
  { label: 'Canada', value: 'canada' },
];

export const nigerianStates = [
  { label: 'Lagos', value: 'lagos' },
  { label: 'Abuja', value: 'abuja' },
  { label: 'Kano', value: 'kano' },
  { label: 'Rivers', value: 'rivers' },
  { label: 'Oyo', value: 'oyo' },
  { label: 'Delta', value: 'delta' },
  { label: 'Edo', value: 'edo' },
  { label: 'Ogun', value: 'ogun' },
  { label: 'Kaduna', value: 'kaduna' },
  { label: 'Enugu', value: 'enugu' },
];

export const cities = [
  { label: 'Lagos Island', value: 'lagos_island' },
  { label: 'Ikeja', value: 'ikeja' },
  { label: 'Lekki', value: 'lekki' },
  { label: 'Victoria Island', value: 'victoria_island' },
  { label: 'Surulere', value: 'surulere' },
  { label: 'Yaba', value: 'yaba' },
  { label: 'Ikoyi', value: 'ikoyi' },
];
